class ContentProviderDirect {
  constructor(html, data = null) {
    this.html = html;
    this.data = data;
  }

  getContent() {
    return Promise.resolve({
      html: this.html,
      data: this.data,
    });
  }
}

export default ContentProviderDirect;



// WEBPACK FOOTER //
// ./src/js/lib/modals/content_providers/ContentProviderDirect.js